export enum ConsumptionDetailTypeEnum {
    OVERSPENT = 'overspent',
    DEFAULT = 'default'
}